export default __webpack_public_path__ + "static/media/4.61095c70.jpg";